import { j as C } from "./AccesRecoveryIcon-CUPieIxT.js";
const l = () => /* @__PURE__ */ C.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", children: [
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      d: "M0 12C0 5.37259 5.37259 0 12 0C18.6274 0 24 5.37259 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12Z",
      fill: "#50AF95"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      d: "M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z",
      stroke: "black",
      strokeOpacity: "0.097"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.4243 12.9468C13.3447 12.9528 12.9337 12.9774 12.0169 12.9774C11.2877 12.9774 10.77 12.9555 10.5883 12.9468C7.7703 12.8226 5.66689 12.331 5.66689 11.7424C5.66689 11.1538 7.7703 10.6629 10.5883 10.5367V12.4572C10.7726 12.4705 11.3003 12.5017 12.0295 12.5017C12.9045 12.5017 13.3427 12.4652 13.4216 12.4579V10.538C16.2337 10.6635 18.3325 11.1551 18.3325 11.7424C18.3325 12.3297 16.2343 12.8213 13.4216 12.9462L13.4243 12.9468ZM13.4243 10.3394V8.62075H17.3487V6H6.6639V8.62075H10.5877V10.3387C7.39841 10.4855 5 11.1186 5 11.8773C5 12.6359 7.39841 13.2684 10.5877 13.4158V18.9231H13.4236V13.4138C16.6056 13.267 19 12.6346 19 11.8766C19 11.1186 16.6076 10.4862 13.4236 10.3387L13.4243 10.3394Z",
      fill: "white"
    }
  )
] });
export {
  l as U
};
